import { useApi } from '@repo-level/core-front';
import type { PropsWithChildren } from 'react';
import { createContext, useEffect } from 'react';
import type { MobileAppApi } from '../api';
import { mobileApp } from '../api';

interface MobileAppContextData {
  data?: MobileAppApi;
  error: boolean;
  pending: boolean;
}

export const MobileAppContext = createContext<MobileAppContextData>(
  null as any
);

export const MobileAppContextProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [requestMobileApp, { error, pending, data }] = useApi(mobileApp);

  useEffect(() => {
    requestMobileApp();
  }, [requestMobileApp]);

  return (
    <MobileAppContext.Provider value={{ data, error, pending }}>
      {children}
    </MobileAppContext.Provider>
  );
};
